import { put } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { SET_POPUP } from '../constants/constants';

export function* setPopupFunc(data) {
  if (data.payload.customPopupMessage) {
    yield delay(4000);
    yield put({
      type: SET_POPUP,
      payload: { ...data.payload, customPopupMessage: false },
    });
  }
}

export function setPopup(data) {
  return {
    type: SET_POPUP,
    payload: data,
  };
}
